<div class="row">
    <div class="verification-container col-xs-12">
        <h3>Verify your Identity</h3>

        <div class="d-flex align-items-center verification-content">
            <div class="d-flex align-items-center justify-content-center list-item">a</div>
            <h5 class="active-item mr-4 pr-4">Verify PAN Card</h5>

            <div class="d-flex align-items-center justify-content-center list-item inactive">b</div>
            <h5 class="verification-item">Verify Mobile Number</h5>
        </div>
    </div>

    <div class="col-xs-12 col-md-10 col-lg-10 mt-3">
        <form #verificationForm="ngForm">
            <div class="form-group">
                <label for="pan">PAN will help us identify you</label>
                <input class="form-control bg-white" id="pan" name="pan" [(ngModel)]="pan" readonly/>

                <div class="form-control mt-3 input-group-container">
                    <div class="input-group d-flex justify-content-between">
                        <input title="Please enter your name" id="nameInput" name="name" [(ngModel)]="inviteeName"
                               #nameInput="ngModel" appNameFormat [maxLength]="50" required/>

                        <div class="input-group-append d-flex">
                            <button type="button" class="suffix-button" *ngIf="!isLoading"
                                    (click)="verifyPan(inviteeName)">Verify
                            </button>
                            <mat-spinner class="align-self-center mr-1" [diameter]="25" *ngIf="isLoading"></mat-spinner>
                        </div>
                    </div>
                </div>

                <small class="text-error" *ngIf="nameInput.errors?.name">{{nameInput.errors?.name}}</small>
            </div>
        </form>
    </div>

    <div class="col-xs-12" *ngIf="!isLoading">
        <small class="color-pastel-orange warning" *ngIf="nameMismatch()">Looks like the name provided does not match
            the PAN. Please follow the instructions specified below:
        </small>

        <div class="background-approximate-snow px-4 py-3 mb-3 mt-2" *ngIf="nameMismatch()">
            <p>A name mismatch issue may be resolved by entering your name in its full form.</p>
            <p>For example:<br>
                <i class="fa fa-times-circle pr-1"></i> If your PAN has <b class="color-pure-black">Rahul K S</b>.<br>
                <i class="fa fa-check-circle pr-1"></i> Please enter the full form - <b class="color-pure-black">Rahul
                    Kumar
                    Singh</b> and try again
            </p>
            <p class="m-0">If you continue facing an issue verifying your PAN, please write to us at
                <span class="color-finzy-blue">support@finzy.com</span>
            </p>
        </div>

        <small class="text-error" *ngIf="invalidPan()">Looks like we have an invalid PAN associated with this
            invitation. Please get in touch with <span class="font-bold">{{invitedByName | titlecase}}</span> to
            update the correct PAN and send you a new invitation.
        </small>

        <small class="text-error" *ngIf="unknownError()">Something went wrong, please try again.</small>
    </div>
</div>
